module.exports = __webpack_public_path__ + "assets/img/block-hover-685bd89a.png";